<template>
  <el-dialog title="工单派单" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
    <el-form :model="dispatchHousekeepingInfo" label-width="120px">
      <el-form-item v-if="dispatchHousekeepingInfo.action == 'BACK'" label="上级处理人">
        <el-input v-model="dispatchHousekeepingInfo.staffName" placeholder="必填，请填写上级处理人" disabled>
        </el-input>
      </el-form-item>
      <el-form-item v-else label="工单师傅">
        <el-select v-model="dispatchHousekeepingInfo.staffId" placeholder="必填，请选择工单师傅" style="width:100%">
          <el-option disabled value="" label="必填，请选择工单师傅">
          </el-option>
          <el-option v-for="(item, index) in dispatchHousekeepingInfo.servUsers" :key="index" :label="item.staffName"
            :value="item.staffId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理意见">
        <el-input type="textarea" :rows="3" placeholder="必填，请填写处理意见" v-model="dispatchHousekeepingInfo.context">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="_dispatchHousekeepingInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { poolDispatch } from '@/api/housekeeping/housekeepingDispatchManageApi'
import { queryHousekeepingServUser } from '@/api/housekeeping/housekeepingDispatchManageApi'

export default {
  name: 'DispatchHousekeeping',
  data() {
    return {
      dialogVisible: false,
      dispatchHousekeepingInfo: {
        poolId: '',
        servId: '',
        staffId: '',
        staffName: '',
        context: '',
        action: '',
        servUsers: [],
        shopId: ''
      }
    }
  },
  methods: {
    open(pool) {
      this.dispatchHousekeepingInfo = {
        ...this.dispatchHousekeepingInfo,
        servId: pool.servId,
        poolId: pool.poolId,
        action: pool.action
      }

      if (pool.action == 'BACK') {
        this.dispatchHousekeepingInfo.staffId = pool.preStaffId
        this.dispatchHousekeepingInfo.staffName = pool.preStaffName
      }

      this._listServUsers()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.clearDispatchHousekeepingInfo()
    },
    async _listServUsers() {
      const params = {
        page: 1,
        row: 50,
        shopId: getShopId(),
        servId: this.dispatchHousekeepingInfo.servId,
        state: '9999'
      }

      try {
        const res = await queryHousekeepingServUser(params)
        this.dispatchHousekeepingInfo.servUsers = res.data
      } catch (error) {
        console.error('获取服务人员失败:', error)
      }
    },
    dispatchHousekeepingValidate() {
      if (!this.dispatchHousekeepingInfo.poolId) {
        this.$message.error('报修单不能为空')
        return false
      }

      if (!this.dispatchHousekeepingInfo.staffId && !this.dispatchHousekeepingInfo.staffName) {
        this.$message.error('报修师傅不能为空')
        return false
      }

      if (!this.dispatchHousekeepingInfo.context) {
        this.$message.error('处理意见不能为空')
        return false
      }

      return true
    },
    async _dispatchHousekeepingInfo() {
      if (!this.dispatchHousekeepingValidate()) {
        return
      }

      this.dispatchHousekeepingInfo.servUsers.forEach(item => {
        if (item.staffId == this.dispatchHousekeepingInfo.staffId) {
          this.dispatchHousekeepingInfo.staffName = item.staffName
        }
      })

      this.dispatchHousekeepingInfo.shopId = getShopId()

      try {
        const res = await poolDispatch(this.dispatchHousekeepingInfo)
        if (res.code === 0) {
          this.$message.success('操作成功')
          this.handleClose()
          this.$emit('dispatch-success')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('操作失败')
      }
    },
    clearDispatchHousekeepingInfo() {
      this.dispatchHousekeepingInfo = {
        poolId: '',
        servId: '',
        staffId: '',
        staffName: '',
        context: '',
        action: '',
        servUsers: [],
        shopId: ''
      }
    }
  }
}
</script>